export default __webpack_public_path__ + "static/media/Love01.3ce0e8b5.png";